import { useEffect, useState } from 'react';

import { loggedInUserDataStore } from '../../../../../shared/stores/loggedInUserDataStore';
import { whatsNewService } from '../../../../services/whatsNewService';
import { WhatsNewContent } from '../../../../interface/whatsNew';
import { getFilteredTruthyFieldsObj } from '../../../../../shared/utils/sortingAndGroupingUtil';

type UseWhatsNewContentReturn = {
  content: WhatsNewContent | null;
};

//Consumer component should be MobX observer
export const useWhatsNewContent = (): UseWhatsNewContentReturn => {
  const [content, setContent] = useState<WhatsNewContent | null>(null);

  const { loggedInUser } = loggedInUserDataStore;

  const getWhatsNewContent = async () => {
    if (!loggedInUser?.id) return;

    const contentResponse = await whatsNewService.getContent(loggedInUser.id);

    const filteredContent = getFilteredTruthyFieldsObj(contentResponse);

    if (filteredContent) {
      setContent(filteredContent);
    }
  };

  useEffect(() => {
    getWhatsNewContent();
  }, [loggedInUser?.id]);

  return { content };
};
